/**
 * Indian states and union territories — the one list every address form
 * offers in its State dropdown (GST place-of-supply depends on the name being
 * consistent, so free text is not allowed).
 */
export const INDIAN_STATES: string[] = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana',
  'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
  'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
];

/** Only India is supported for now; country fields are fixed to this. */
export const DEFAULT_COUNTRY = 'India';

/**
 * Map a free-text state (GSTIN lookup, older records: "TELANGANA",
 * "telangana ", "NCT of Delhi") onto the canonical list entry. Returns the
 * input unchanged when nothing matches, so the value is never silently lost.
 */
export function canonicalIndianState(value: string | null | undefined): string {
  const raw = (value ?? '').trim();
  if (!raw) return '';
  const norm = (s: string) => s.toLowerCase().replace(/&/g, 'and').replace(/[^a-z]/g, '');
  const n = norm(raw);
  const exact = INDIAN_STATES.find((s) => norm(s) === n);
  if (exact) return exact;
  if (n.includes('delhi')) return 'Delhi';
  if (n === 'orissa') return 'Odisha';
  if (n === 'pondicherry') return 'Puducherry';
  return raw;
}
